const isDropdownLink = element => element && element.className === "nav-dropdown-toggle"

export function startDropdowns() {
  document.addEventListener("DOMContentLoaded", () => {
    var openDropdown = null

    document.addEventListener("click", (event) => {
      let closedDropdown = null

      // If there is an open dropdown, close it
      if (openDropdown) {
        openDropdown.classList.add("collapsed")
        closedDropdown = openDropdown
        openDropdown = null
      }

      if (isDropdownLink(event.target) || isDropdownLink(event.target.parentElement)) {
        event.preventDefault()

        // If the current dropdown was the open dropdown, return
        let currentDropdownLink = event.target
        let currentDropdownContainer = currentDropdownLink.closest(".dropdown-container")
        let currentDropdown = currentDropdownContainer.querySelector(".dropdown")

        if (currentDropdown === closedDropdown) {
          return
        }

        // Open the current dropdown
        openDropdown = currentDropdown
        openDropdown.classList.remove("collapsed")
      }
    })
  });
}
